import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGeneral } from "@/contexts/GeneralContext";
import { PATH_TO_TAB_MAP, NO_TAB_PAGES, SIDEBAR_PAGES } from "../constants";

/**
 * Custom hook to handle navbar navigation logic
 * Manages active tab state based on current route
 */
export const useNavbarNavigation = () => {
  const { activeTab, setActiveTab } = useGeneral();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    // Don't set any active tab for special pages (profile, notifications, alarm-detail, admin pages)
    if (
      NO_TAB_PAGES.includes(currentPath as any) ||
      currentPath.startsWith("/profile") ||
      currentPath.startsWith("/notifications") ||
      currentPath.startsWith("/admin")
    ) {
      setActiveTab("");
      return;
    }

    // For Dashboard page
    if (currentPath === "/dashboard") {
      setActiveTab("Dashboard");
      return;
    }

    // For Fleet-related pages (all paths starting with /fleet)
    if (currentPath.startsWith("/fleet")) {
      setActiveTab("Fleet");
      return;
    }

    // For Unit-related pages (all paths starting with /units, /wagons, /bogies)
    if (
      currentPath.startsWith("/units") ||
      currentPath.startsWith("/wagons") ||
      currentPath.startsWith("/bogies")
    ) {
      setActiveTab("Unit");
      return;
    }

    // For all other pages, try to find a matching tab
    const tabName = PATH_TO_TAB_MAP[currentPath];
    if (tabName) {
      setActiveTab(tabName);
    } else {
      setActiveTab("");
    }
  }, [location.pathname, setActiveTab]);

  return {
    activeTab,
    setActiveTab,
  };
};
